export default "__VITE_ASSET__DRxHso29__ 480w, __VITE_ASSET__BWcdTWpZ__ 768w, __VITE_ASSET__BCjeXBsl__ 1200w, __VITE_ASSET__CqF14d5$__ 1600w";